import { getCouponEligibleItems, isItemAffectedByCoupon } from '@src/domains/coupons/core/couponEligibleItems';
import { isCouponValid } from '@src/domains/coupons/core/isCouponValid';
import type {
  CouponInput,
  CouponProductScope,
  ItemWithProductName,
} from '@src/domains/coupons/types/couponProductScope';

const toCouponProductScope = (coupon: CouponInput, sellerAppId?: string): CouponProductScope => ({
  ...coupon,
  sellerAppId,
});

export const getCouponAffectedProductNames = (
  coupon: CouponInput | null | undefined,
  items: ItemWithProductName[],
  sellerAppId?: string,
): string[] => {
  if (!isCouponValid(coupon)) {
    return [];
  }

  const scope = toCouponProductScope(coupon, sellerAppId);
  const productNames = new Set<string>();

  getCouponEligibleItems(items)
    .filter((item) => isItemAffectedByCoupon(item, scope))
    .forEach((item) => {
      productNames.add(item.product.name);
    });

  return Array.from(productNames);
};
